export default {"src":"/_next/static/media/logo.7a4209a4.svg","height":96,"width":297,"blurWidth":0,"blurHeight":0};